export enum EEslTemplateElementMovementMode {
    None,
    Horizontal,
    Vertical,
    Random,
}
